<template>
  <div>
    <a-modal
      v-model="isShow"
      centered
      :mask-closable="false"
      :ok-button-props="{ props: { loading: submitting } }"
      title="编辑逝者生平简介"
      @ok="handleSubmit"
    >
      <a-form
        class="custom-compact-form"
        :form="form"
        :label-col="{ span: 0 }"
        :wrapper-col="{ span: 24 }"
        @submit="handleSubmit"
      >
        <a-form-item label="生平简介">
          <a-textarea
            :rows="10"
            placeholder="请输入生平简介"
            v-decorator="['life_info', {
              initialValue: lifeInfo,
              rules: [
                { required: true, message: '请输入生平简介' },
                { max: 1000, message: '最多1000个字符' },
              ]
            }]"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { updateServiceOrderDeathLifeInfo } from '@/api/service_order_death'

export default {
  name: 'EditServiceOrderDeathLifeInfo',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    id: {
      type: Number,
      required: true
    },
    lifeInfo: {
      type: String,
      default: function() {
        return ''
      }
    }
  },
  data() {
    return {
      form: this.$form.createForm(this, { name: 'Destination' }),
      submitting: false,
      data: {}
    }
  },
  computed: {
    isShow: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault()
      if (this.submitting) {
        this.$warning({
          title: '请勿重复提交',
          content: ''
        })
        return
      }
      this.form.validateFields((err, values) => {
        if (!err) {
          this.submitting = true
          updateServiceOrderDeathLifeInfo(this.id, values).then((res) => {
            if (res.code === 0) {
              // 关闭模态框
              this.isShow = false
              // 告知父组件已完成
              this.$emit('completed')
            }
            this.submitting = false
          })
        }
      })
    }
  }
}
</script>
